import type { AppState } from 'state/state.model';

function getValuationDateCalendars(state: AppState) {
  return state.valuationDateCalendars;
}

export function getUnknownValuationDateCalendars(state: AppState, valuationDatesCalendars: string[]): string[] {
  const knownValuationDatesCalendars = Object.keys(getValuationDateCalendars(state));
  return valuationDatesCalendars.filter(cal => !knownValuationDatesCalendars.includes(cal));
}
